import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'reportData',
  standalone: false,
})
export class ReportDataPipe implements PipeTransform {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  transform(value: any, args?: any): any {
    if (value === -1 || value === null) {
      return '-';
    } else {
      return value;
    }
  }
}
